import { Modal } from 'antd'

interface CreditRefillPolicyModalProps {
   open: boolean
   onClose: () => void
}

export const CreditRefillPolicyModal = ({
   open,
   onClose,
}: CreditRefillPolicyModalProps) => {
   return (
      <Modal
         open={open}
         onCancel={onClose}
         title=""
         footer={null}
         className="ff-modal"
         width={720}
      >
         <div className="flex flex-col gap-6 py-6">
            {/* Title */}
            <h2 className="text-white text-2xl font-semibold border-b">
               Credit Refill Policy
            </h2>

            {/* Content Section */}
            <div className="">
               <h3 className="text-white text-lg font-medium mb-4">
                  How your credits are refilled
               </h3>
               <ul className="space-y-3 text-white text-base">
                  <li className="flex items-start">
                     <span className="mr-3 mt-1.5 w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>
                     <span>
                        We'll auto-purchase $100 credits at a time whenever your
                        wallet runs as low as $20.
                     </span>
                  </li>
                  <li className="flex items-start">
                     <span className="mr-3 mt-1.5 w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>
                     <span>
                        Forward Flow keeps track of your revive campaign's
                        monthly limit - and stops purchases once that limit is
                        hit.
                     </span>
                  </li>
                  <li className="flex items-start">
                     <span className="mr-3 mt-1.5 w-1.5 h-1.5 rounded-full bg-white flex-shrink-0"></span>
                     <span>
                        You can pause or stop anytime - unused credits will stay
                        available in your account.
                     </span>
                  </li>
               </ul>
            </div>
         </div>
      </Modal>
   )
}
